const clientEmail = document.querySelector('meta[name="client-email"]').content;

const initialState = {
  cHash: document.querySelector('meta[name="c-hash"]').content,
  tagId: document.querySelector('meta[name="tag-id"]').content,
  chatUrl: document.querySelector('meta[name="chat-url"]').content,
  apiUrl: document.querySelector('meta[name="api-url"]').content,
  messages: [],
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  locale: document.querySelector('meta[name="locale"]').content,
  title: document.querySelector('meta[name="title"]').content,
  onlineConsulatant: document.querySelector('meta[name="oncline-consultant"]').content,
  conversationStatus: 0,
  usersTyping: [],
  operator: null,
  operatorStatus: false,
  unreaded: 0,
  closed: false,
  companyStatus: false,
  isUploading: false,
  pageUrl: null,
  browserLang: null,
  browserVersion: null,
  isClient: (clientEmail) ? true : false,
  conversationStarted: false,
  messageToSend: null,
  emailValidation: true,
  clientEmail: clientEmail,
  clientName: document.querySelector('meta[name="client-name"]').content,
  sendToAIAssistant: false,
  hideTalkToHuman: false,
  textarea: {
    defaultHeight: 24,
    currentHeight: 24,
    rows: 1,
    diffHeight: 0
  },
  disableReply: false
};
  
export const app = (state = initialState, action) => {
  switch (action.type) {

    case "CHANNEL_DISABLE":
      return {
        ...state,
        disableReply: true
      }

    case "CHANNEL_ENABLE":
      return {
        ...state,
        disableReply: false
      }

    case "TEXTAREA_HEIGHT":
      return { 
        ...state,
        textarea: {
          ...state.textarea,
          currentHeight: action.height,
          rows: action.rows,
          diffHeight: action.height - state.textarea.defaultHeight
        }
      }

    case "SET_EMAIL_INVALID":
      return { ...state, emailValidation: false };

    case "SEND_MESSAGE":
      return { ...state, conversationStarted: true };

    case "INIT_SUCCESS":
      if (state.clientEmail) {
        return { 
          ...state, 
          conversationStarted: action.config.conversationStarted,
          sendToAIAssistant: action.config.sendToAIAssistant,
          hideTalkToHuman: action.config.hideTalkToHuman,
          disableReply: action.config.disableReply
        };
      }

      return { 
        ...state,
        isClient: action.config.isClient,
        conversationStarted: action.config.conversationStarted,
        sendToAIAssistant: action.config.sendToAIAssistant,
        hideTalkToHuman: action.config.hideTalkToHuman,
        disableReply: action.config.disableReply
      };

    case "SET_IS_CLIENT":
      return { ...state, isClient: true };

    case "SET_MESSAGE_TO_SEND":
      return { ...state, messageToSend: action.message }

    case "SET_INIT":
      return { ...state, pageUrl: action.url, browserLang: action.lang, browserVersion: action.browser }

    case "START_UPLOAD":
      return { ...state, isUploading: true }

    case "END_UPLOAD":
      return { ...state, isUploading: false }

    case "END_UPLOAD_ERROR":
      return { ...state, isUploading: false }

    case "SET_SCROLLED":
      return { ...state, isScrolled: action.status }

    case "COMPANY_STATUS":
      return { ...state, companyStatus: action.payload.message.status }

    case "SET_USER_STATUS":
      if (!state.operator) {
        return { ...state };
      }

      if (state.operator.id != action.userId) {
        return { ...state };
      }

      return { ...state, operatorStatus: action.status };

    case "LOAD_MESSAGES_SUCCESS":
      if (action.messages.length == 0) {
        return { ...state };
      }

      return { 
        ...state, 
        messages: action.messages,
        conversationStatus: action.messages[0].conversation_status,
        operator: (action.operator && action.operator.id) ? action.operator : null
      }

    case "STATUS_CHANGE":
      return {
        ...state,
        conversationStatus: action.payload.message.conversation_status
      }

    case "REPLACE_MESSAGE":
      return {
        ...state,
        messages: state.messages.map(message => message.id == action.payload.message.id
          ? { ...action.payload.message }
          : { ...message }
        )
      };

    case "BUTTON_CLICKED":
        return {
          ...state,
          messages: state.messages.map(message => message.id == action.payload.message.message_id
            ? {...message,
              actionButtons: message.actionButtons.map(actionButton => actionButton.id == action.payload.message.button_id
                ? { ...actionButton,
                  isClicked: true
                }
                : { ...actionButton }
              )
            }
            : {...message}
          )
        };

    case "NEW_MESSAGE":

      if (action.payload.message.hidden) {
        return { ...state };
      }

      // if (action.payload.message.empty !== undefined) {
      //   return { ...state };
      // }

      var disableReply = null;
      if (action.payload.message.unlockDisableReplyChannel !== undefined) {
        disableReply = false;
      }
      if (action.payload.message.disableReplyChannel !== undefined) {
        disableReply = true;
      }

      if (state.messages.length >= 50) {
        return { 
          ...state,
          messages: [...state.messages.slice(1), action.payload.message],
          operator: (action.payload.message.fromClient) ? state.operator : action.payload.message.user,
          disableReply: (disableReply !== null) ? disableReply : state.disableReply
        }
      } else {
        return { 
          ...state,
          messages: [...state.messages, action.payload.message],
          operator: (action.payload.message.fromClient) ? state.operator : action.payload.message.user,
          disableReply: (disableReply !== null) ? disableReply : state.disableReply
        }
      }

    case "MESSAGE_CONVERSATION_REMOVED": 
      return { 
        ...state,
        messages: state.messages.filter(message => message.id != action.payload.message.id)
      }

    case "USER_START_TYPING":
      return {
        ...state,
        usersTyping: state.usersTyping.filter(typing => typing.userId != action.payload.message.userId).concat({ userId: action.payload.message.userId, username: action.payload.message.username })
      };

    case "USER_END_TYPING":

      return {
        ...state,
        usersTyping: state.usersTyping.filter(typing => typing.userId != action.payload.message.userId)
      };

    case "TALK_TO_HUMAN_SUCCESS":
      return {
        ...state,
        sendToAIAssistant: false
      }

    default:
      return state;
  }
}